(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ModBusTypeEnum', modbusTypeEnumFactory);

  function modbusTypeEnumFactory () {
    return Object.freeze({
      SERIAL: 'SERIAL',
      ETHERNET: 'ETHERNET',
      ETHERNET_241: 'ETHERNET_241'
    });
  }
})();
